'use strict'
import React from 'react'
import MobileDropDown from '../mobile-dropdown.jsx'
import DatePicker from '../date-picker.jsx'
import GoogleInputField from '../google-input-field.jsx'
import GuestsPicker from '../guests-picker.jsx'
import { withTranslation as translate } from 'react-i18next'

class LargePageSearch extends React.PureComponent {
  render () {
    let user = this.props.userId
    return (
      <div className='search'>
        <GoogleInputField
          startDate = {this.props.startDate}
          endDate = {this.props.endDate}
          value={this.props.searchQuery}
          onChange={this.props.onSearchQueryChange}
          placeholder={this.props.t('landing_page_search_placeholder')}
          onReceivedSearchResults={this.props.onReceivedSearchResults}
          locale={this.props.state.locale}
        />
        <MobileDropDown
          onChange={this.props.onMobilityClassChange}
          value={this.props.mobilityClass}
        />
        <DatePicker
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          onDatesChange={this.props.onDatesChange}
          futureOnly="1"
          preOpen={this.props.datesPreOpen}
        />
        <GuestsPicker
          onChange={this.props.onChangeRoomsData}
          // router={this.props.router}
        />
        <button id="search-accomodation" onClick={this.props.onSearchClick}>{this.props.t('landing_page_search_button')}</button>
      </div>
    )
  }
}

export default translate()(LargePageSearch)
